<div  #refElement class="container-fluid stdTheme" *ngIf="okToDisplayMenu"
        [ngStyle]="{margin: '0px', 'margin-top': '0px', width: '100%', padding: '0px'}" >
    <mat-card class="register-card stdTheme wkscard" layout="column" flex 
        style="padding: 0px; padding-right: 5px; padding-left: 5px; height: 100%;padding-bottom: 10px;overflow-x: hidden!important; overflow-y: hidden!important;"
        >
        <mat-card-title style="text-align: center;" >
            <div class="flex-row row" style="margin: 0px; padding: 0px;">
                <div class="col-lg-12 col-xs-12  " style="display: flex;justify-content: center;">
                    {{ 'INVENTORY.TITLE' | translate }}  
                </div>
            </div>
            <div class="flex-row row" style="margin: 0px; padding: 0px;">
                <div class="col-lg-12 col-xs-12" style="display: flex;justify-content: center;">
                    <mat-select id="warehouse" #warehouse panelClass="mdiselectcontent" ngDefaultControl
                        [(value)]="warehouseCur" class="warehousePanel"
                        (selectionChange)="warehouseChoice(warehouse.value)">
                        <mat-option class="selectOptionsTheme" *ngFor="let warehouseCur of wareHousesList"
                            [value]="warehouseCur.warehouseId"> {{warehouseCur.warehouseRef}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
        </mat-card-title> 
        <mat-card-actions style="flex-direction: row;box-sizing: border-box;display: flex;margin-left: 0px;margin-right: 0px;" >
            <button [disabled]="!btnSearchByRef" mat-raised-button (click)="searchByRef()">
                <i class="fa fa-search" aria-hidden="true" style="font-size: 15px"></i>
            </button>
            <div fxFlex></div>
            <button [disabled]="!btnSearchByBarCode" mat-raised-button (click)="searchByBarCode()">
                <i class="fa fa-barcode" aria-hidden="true" style="font-size: 15px"></i>
            </button>
            <div fxFlex></div>
            <button [disabled]="!btnCreateForm" mat-raised-button (click)="addProduct()">
                <i class="fa fa-plus" aria-hidden="true" style="font-size: 15px"></i>
            </button>
            <div fxFlex></div>
            <button [disabled]="!btnQuit" mat-raised-button (click)="logout()" title="{{ 'COMMUN.BUTTON.LOGOUT' | translate }}">
                <!--<i class="fas fa-sign-out" aria-hidden="true" style="font-size: 15px"></i>-->
                <mat-icon>exit_to_app</mat-icon>
            </button>
        </mat-card-actions>
        <mat-card-content class="stdTheme">
            <div *ngIf="doSearchByBarCode">
            <!-- [hidden]="!doSearchByBarCode">-->
                <app-ct37 
                    (scannerEvent)="scannedResponse($event)">
                </app-ct37>
                <div class="flex-row row"  style="margin: 0px; ">
                    <div class="col-lg-12 col-xs-12  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: space-between;">
                        <button style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                            (click)="doCancelSearchByBarcode(); doCancelSearchByRef()">{{'COMMUN.BUTTON.CANCEL' | translate}}
                        </button>
                        <button [hidden]="!btnChangeRef" style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                             (click)="changeRef()">{{'INVENTORY.BTN_CHANGE_REF' | translate}}
                        </button>
                        <button [disabled]="!scannedCode || !btnBarcodeStock" style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                            (click)="launchSearchBarcode(scannedCode); btnBarcodeStock = !btnBarcodeStock">{{'INVENTORY.BTN_STOCK' | translate}}
                        </button>
                    </div>
				</div>
            </div>
            <div *ngIf="doSearchByRef">
                <div class="flex-row row" style="margin: 0px; padding: 0px;">
                    <div class="col-lg-4 col-xs-4"  >
                        <div class="input-group">
                            <input  id="ref" class="form-control inputTheme" 
                                    type="text" name="ref" placeholder="{{ 'INVENTORY.ENTER_REF' | translate: {minCar: MIN_CAR} }}" 
                                    (keyup)="ctrlInputRef(ref.value)"
                                    #ref>         
                        </div>
                    </div>
                </div>
                <div class="flex-row row"  style="margin: 0px; ">
                    <div class="col-lg-12 col-xs-12  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content:  space-between;">
                        <button style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                            (click)="doCancelSearchByRef(); doCancelSearchByBarcode()">{{'COMMUN.BUTTON.CANCEL' | translate}}
                        </button>
                        <button [disabled]="!okToSearch" style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                             (click)="launchSearchReferential(ref.value)">{{'INVENTORY.BTN_STOCK' | translate}}
                        </button>
                    </div>
				</div>
            </div>
            <div *ngIf="displayCreateForm">
                <ng-container  [ngTemplateOutlet]="createFormTemplate"  ></ng-container>
            </div>
            <div *ngIf="displayListProducts" >
                <div  *ngFor= "let productItem of listProducts; let productIdx=index; let c=count;let isLast=last">
                    <div  style="margin: 0px; padding: 0px;"  >
                        <div id="productCur_{{productIdx}}" #productCur_{{productIdx}} style="line-height: 30px;margin-left: 0px;margin-right: 0px;" >
                            
                            <div class="col-lg-9 col-xs-9"  >
                                <span *ngIf="productItem.isCollapsed" class="fa fa-chevron-down" style="font-size: 15px" aria-hidden="true"></span>
                                <span *ngIf="!productItem.isCollapsed" class="fa fa-chevron-up" style="font-size: 15px" aria-hidden="true"></span>
                                <!--
                                <span style="margin: 0px;" (click)="productItem.isCollapsed = !productItem.isCollapsed; readStockByRef(productIdx, false)">
                                    {{ productItem.paramPartsSupplies.brandRef }} <b>{{ productItem.paramPartsSupplies.paramLabel }}</b> 
                                </span>
                                -->
                                <span style="margin: 0px;" (click)="productItem.isCollapsed = !productItem.isCollapsed; readStockByRef(productIdx, false)">
                                    <span class="key-field">
                                        {{ productItem.paramPartsSupplies.brandRef }}
                                    </span>

                                    <!-- 🔹 Mode affichage -->
                                    <ng-container *ngIf="productItem.editingField !== 'paramLabel'; else editParamLabel">
                                        <b class="editable-field"
                                        (dblclick)="enableEdit(productItem, 'paramLabel')"
                                        title="{{'INVENTORY.LABEL_EDIT' | translate}}">
                                        {{ productItem.paramPartsSupplies.paramLabel }}
                                        </b>
                                    </ng-container>

                                    <!-- 🔹 Mode édition -->
                                    <ng-template #editParamLabel>
                                        <input type="text"
                                            [(ngModel)]="productItem.paramPartsSupplies.paramLabel"
                                            class="product-param-label-input"
                                            (focus)="storeInitialValue(productItem, 'paramLabel')"
                                            (blur)="changeParamLabel(productItem, 'paramLabel')"
                                            (keydown.enter)="changeParamLabel(productItem, 'paramLabel')" />
                                    </ng-template> 
                                </span>
                            </div>
                            <div class="col-lg-2 col-xs-2" style="padding-right: 0px;padding-left: 0px;">
    
                            </div>
        
                        </div>
                        <div  [ngbCollapse]="productItem.isCollapsed">
  
                            <div class="flex-row row" style="margin-left: 10px; margin-right: 10px;">
                                <div class="col-lg-3 col-xs-6  " style="padding-left: 0px;padding-right: 0px;">
                                    {{ 'INVENTORY.STOCK_VIRTUAL' | translate }}
                                </div>
                                <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;">
                                    <span>{{productItem.stockVirtual | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}</span>
                                </div>
                                <div class="col-lg-3 col-xs-6  " style="padding-left: 0px;padding-right: 0px;">
                                    {{ 'INVENTORY.STOCK_PHYSICAL' | translate }}
                                </div>
                                <!--
                                (click)="unformatNumeric('stockPhysical')"
                                -->
                                <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;">
                                    <input class="form-control inputTheme" name="stockPhysical" id="stockPhysical" #stockPhysical [ngStyle]="{'text-align': numberFormat.justifNumbers}" 
                                        type="text"
                                        inputmode="numeric"
                                        value="{{productItem.stockPhysical | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}"
                                        (click)="unformatNumeric('stockPhysical')"
                                        matInput (keypress)="numberAndDotOnly($event)" (change)="setStockPhysical(stockPhysical.value, productIdx)"/> 
                                </div>
                            </div>
                             <div class="flex-row row" style="margin-left: 10px; margin-right: 10px;">
                                <div class="col-12 " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: end;">
                                    <button  [disabled]="!productItem.isOkToValid" class="mat-raised-button buttonTheme" 
                                        mat-dialog-close style="margin-bottom: 10px;" 
                                        (click)="updateProduct('update', productIdx)" >{{'COMMUN.BUTTON.SUBMIT' | translate}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>

</div>
<ng-template let-value="valueArg" #createFormTemplate>
    <div class="flex-row row"  style="margin: 0px; margin-top: 15px;">
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.BRAND' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <mat-select id="brandName" #brandName panelClass="mdiselectcontent" ngDefaultControl
                placeholder=" {{ 'INVENTORY.CREATEFORM.BRAND' | translate }}"
                (selectionChange)="createFormBrand(brandName.value)">
                <mat-option class="selectOptionsTheme" *ngFor="let brandCur of brandsList"
                    [value]="brandCur.brandName"> {{brandCur.brandName}}
                </mat-option>
            </mat-select>
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.REF' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="ref" #ref  id="ref"
                (input)="onInputChangeRef('ref')"
                placeholder="{{ partsRules.partsRefMask }}" 
                type="text"  matInput (change)="createFormRef(ref.value)" /> 
        </div>
    </div>    
    <div class="flex-row row"  style="margin: 0px; margin-top: 15px;">
       
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.BARCODE' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="nwsBarcode" #nwsBarcode  id="nwsBarcode"
                (input)="onInputChangeBarcode('nwsBarcode')"
                placeholder="" 
                type="text"  matInput (change)="createFormBarcode(nwsBarcode.value)" /> 
                <div class="input-group-append inputTheme">                             
                    <i class="fa fa-clipboard" aria-hidden="true" 
                        [disabled]="!this.scannedCode"
                        (click)="copyBarcode()">
                    </i>   
                </div>  
        </div>
        
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.BARCODETYPE' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <span>{{createValues.nwsBarcodeType}}</span>
            <!--
            <select class="selectBox inputTheme" #barcodeType 
                (change)="createFormBarcodeType(barcodeType.value)">
                <option *ngFor="let barCode of barCodes" 
                        [value]="barCode.code"
                        >{{ barCode.code }}
                </option>
            </select>
            -->
        </div>
        
    </div>
    <div class="flex-row row"  style="margin: 0px; margin-top: 15px;">
    <!-- label -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.LABEL' | translate }}
        </div>
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="label" #label id="label"
                placeholder="{{ partsRules.partsLabelMask }}"
                (input)="onInputChangeLabel('label')"
                type="text"  matInput (change)="createFormLabel(label.value)" /> 
        </div>
    <!-- unit -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.UNIT' | translate }}
        </div>
        <!-- value="{{createValues.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}" -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <select class="selectBox inputTheme" #paramUnit 
                (change)="createFormUnit(paramUnit.value)">
                <option *ngFor="let unitQuantity of unitsQuantity" 
                        [value]="unitQuantity.value"
                        >{{ unitQuantity.label }}
                </option>
            </select>
        </div>
    <!-- quantity -->
        <div class="col-lg-2 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: center;">
            {{ 'INVENTORY.CREATEFORM.QTY' | translate }}
        </div>
        <!-- value="{{createValues.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}" -->
        <div class="col-lg-1 col-xs-6  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: start;">
            <input class="form-control inputTheme" name="quantity" #quantity [ngStyle]="{'text-align': numberFormat.justifNumbers}" 
                type="text"
                value="{{createValues.quantity | formatNumber : ['quantity',numberFormat.locale,numberFormat.minDecimal, numberFormat.maxDecimal]}}"
                matInput (keypress)="numberAndDotOnly($event); "
                (change)="createFormQty(quantity.value)" /> 
        </div>
    </div>
    <div class="flex-row row"  style="margin: 0px; ">
        <div class="col-lg-12 col-xs-12  " style="padding-left: 0px;padding-right: 0px;display: flex;justify-content: space-between;">
            <button style="margin-left:10px; margin-right: 40px;" class="mat-raised-button buttonTheme" mat-dialog-close 
                (click)="doCancelCreateForm()">{{'COMMUN.BUTTON.CANCEL' | translate}}
            </button>
            <button  [disabled]="!okToCreate" class="mat-raised-button buttonTheme" 
                style="margin-bottom: 10px;" (click)="createProduct()" >{{'COMMUN.BUTTON.SUBMIT' | translate}}
            </button>
        </div>
    </div>
</ng-template>